<template>
  <div
    id="map"
    class="map">
  </div>
</template>
<script>
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable default-case */
import 'ol/ol.css';
import axios from 'axios';
import moment from 'moment';

import debounce from 'lodash.debounce';
import cloneDeep from 'lodash.clonedeep';

import Map from 'ol/Map';
import View from 'ol/View';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';


import {
  GeoJSON,
  EsriJSON,
} from 'ol/format';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

import {
  Tile as TileLayer,
  Image as ImageLayer,
} from 'ol/layer';

import {
  ImageArcGISRest,
  ImageWMS,
  XYZ,
} from 'ol/source';

import {
  Circle as CircleStyle,
  Icon,
  Fill,
  Stroke,
  Style,
  Text,
} from 'ol/style';

import {
  defaults as defaultControls,
  ScaleLine,
} from 'ol/control';

import {
  fromLonLat,
  toLonLat,
  transformExtent,
} from 'ol/proj';

import {
  point,
  circle,
  booleanIntersects,
  pointsWithinPolygon,
  bboxPolygon,
} from '@turf/turf';

import { mapGetters, mapState, mapActions } from 'vuex';
import { evaluate } from 'bcx-expression-evaluator';

import { style } from '../assets/js/styles';

const firmsKeys = [
  process.env.VUE_APP_FIRMS_0,
  process.env.VUE_APP_FIRMS_1,
  process.env.VUE_APP_FIRMS_2,
  process.env.VUE_APP_FIRMS_3,
  process.env.VUE_APP_FIRMS_4,
  process.env.VUE_APP_FIRMS_5,
  process.env.VUE_APP_FIRMS_10,
  process.env.VUE_APP_FIRMS_11,
  process.env.VUE_APP_FIRMS_12,
];

const scaleLineControl = new ScaleLine();
scaleLineControl.setUnits('metric');

let map;
let mapView;
let positionFeature;
let positionBuffer;
let positionStyle;
let positionBufferStyle;
// eslint-disable-next-line no-unused-vars
let positionLayer;

const defaultTextStyle = new Text({
  textAlign: 'left',
  placement: 'wrap',
  offsetX: 18,
  font: '12px Arial',
  align: 'center',
  baseline: 'middle',
  fill: new Fill({
    color: '#003D6B',
  }),
  stroke: new Stroke({
    color: '#cccccc',
    width: 3,
  }),
});

export default {
  name: 'MapView',

  data() {
    return {
      layers: [],
      rangeableFeaturesCollections: [],
      inRangeFeatures: [],
      inRangeFires: [],
      labelBreakpoint: 38,
      rangerLayer: null,
      clickStartTime: 0,
    };
  },

  computed: {
    ...mapState([
      'title',
      'mapViewState',
      'navigationState',
      'version',
      'layerState',
      'siteId',
      'plumeURL',
      'dbTimeout',
      'coordinates',
      'range',
    ]),
    ...mapGetters([
      'getNavigationControlById',
      'getIsDetailsViewVisible',
      'getCoordinates',
    ]),
  },

  watch: {
  },

  created() {
    this.$bus.$on('map-resize', this.mapResizeHandler);
    this.$bus.$on('layer-visibility', this.layerVisibilityHandler);
    this.$bus.$on('fly-to', this.flyToHandler);
    this.$bus.$on('update-layers-from-sources', this.updateLayersFromSourcesHandler);
    this.$bus.$on('map-geolocate', this.geolocateHandler);
    this.$bus.$on('reorder-layers', this.reorderLayersHandler);
    this.$bus.$on('update-layer-opacity', this.layerOpacityHandler);
  },

  beforeDestroy() {
    this.$bus.$off('map-resize');
    this.$bus.$off('layer-visibility');
    this.$bus.$off('fly-to');
    this.$bus.$off('update-layers-from-sources');
    this.$bus.$off('map-geolocate');
    this.$bus.$off('reorder-layers');
    this.$bus.$off('update-layer-opacity');
  },

  mounted() {
    map = this.initializeMap();

    // initalize map view state
    // get from DB
    // set in mapViewState
    mapView = this.updateMapView(
      this.mapViewState.center,
      this.mapViewState.zoom,
    );

    map.setView(mapView);
    this.mapResizeHandler();

    // initialize layers as reactive
    this.layers = cloneDeep(this.layerState);

    this.initializeLayers(this.layers);


    positionFeature = new Feature();
    positionBuffer = new Feature();
    positionStyle = new Style({
      image: new CircleStyle({
        radius: 6,
        fill: new Fill({
          color: '#3399CC',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 2,
        }),
      }),
      text: defaultTextStyle,
    });
    positionBufferStyle = new Style({
      stroke: new Stroke({
        color: '#ffffff',
        width: 1,
      }),
      fill: new Fill({
        color: 'rgba(51, 153, 204, 0.2)',
      }),
    });

    positionFeature.setStyle(positionStyle);
    positionBuffer.setStyle(positionBufferStyle);
    positionFeature.setGeometry(null);
    positionBuffer.setGeometry(null);

    positionLayer = new VectorLayer({
      map,
      source: new VectorSource({
        features: [positionFeature, positionBuffer],
      }),
    });

    // map.on('originalEvent', evt => console.log('>>>>>>>>>> originalEvent >>>>> ', evt));
    map.on('singleclick', evt => this.featuresInformationDisplay(evt));
    map.on('dblclick', evt => this.processRanger(evt));


    map.on('moveend', debounce(evt => this.mapMoveEndHandler(evt), 500));
  },

  methods: {
    // import actions from store
    ...mapActions([
      'setTilesArray',
      'setDetailViewVisible',
      'pushToTilesArray',
      'setMapViewStateCenter',
      'setMapViewStateZoom',
      'setNavigationLoadState',
      'setNavigationActive',
      'setLayers',
      'setCoordinates',
      'setInRangeFeatures',
    ]),

    clearRanger() {
      this.clearRangerVisual();
      this.setInRangeFeatures([]);
    },

    clearRangerVisual() {
      positionFeature.setGeometry(null);
      positionBuffer.setGeometry(null);
      positionFeature.getStyle().getText().setText('');
    },

    processRanger(evt) {
      // clear ranger
      this.clearRanger();
      const lonLat = toLonLat(evt.coordinate);
      const lon = Math.round(lonLat[0] * 1000000) / 1000000;
      const lat = Math.round(lonLat[1] * 1000000) / 1000000;

      positionFeature.setGeometry(new Point(evt.coordinate));
      const turfPoint = point([lon, lat]);
      this.setCoordinates(turfPoint);

      // Ranger Constants
      const format = new GeoJSON();
      const projection = map.getView().getProjection();
      const units = 'kilometers';
      // create ranger Circle
      const bufferCircle = circle(turfPoint, this.range, { units, steps: 15 });
      const bufferFeature = format.readFeatures(bufferCircle,
        {
          dataProjection: 'EPSG:4326',
          featureProjection: projection,
        });
      positionBuffer.setGeometry(bufferFeature[0].getGeometry()); // add to layer

      const featuresInRange = [];
      this.getRangerLayers(this.layers).forEach((layer) => {
        const source = layer.layer.getSource();
        const features = source.getFeatures();
        const tempGeoJson = JSON.parse(format.writeFeatures(features, { featureProjection: 'EPSG:3857', dataProjection: 'EPSG:4326' }));
        const geoType = tempGeoJson.features.length ? tempGeoJson.features[0].geometry.type : null;

        if (geoType === 'Point') {
          const points = pointsWithinPolygon(
            tempGeoJson,
            bufferCircle,
          );
          featuresInRange
            .push({ id: layer.id, title: layer.popup.title, features: points.features });
        }
        if (geoType === 'Polygon' || geoType === 'MultiPolygon') {
          const featureArray = [];
          tempGeoJson.features.forEach((feature) => {
            if (booleanIntersects(bufferCircle, feature)) {
              if (!feature.properties.FIRE_STATUS) {
                // eslint-disable-next-line no-param-reassign
                feature.properties.FIRE_STATUS = 'NRT';
                feature.properties.FIRE_NUMBER = 'Active Perimeter';
              }
              featureArray.push(feature);
            }
          });
          featuresInRange.push({ id: layer.id, title: layer.popup.title, features: featureArray });
        }
      });
      console.log('featuresInRange :: ', featuresInRange);
      this.setInRangeFeatures(featuresInRange);

      evt.preventDefault();
      setTimeout(() => {
        this.clearRangerVisual();
      }, 30000);
    },

    firmsKey() {
      return firmsKeys[Math.floor(Math.random() * firmsKeys.length)];
    },

    featuresInformationDisplay(evt) {
      this.clearRanger();

      const tilesArray = [];
      // clear the store
      this.setTilesArray(tilesArray);

      // eslint-disable-next-line no-unused-vars
      map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
        const { layerId } = feature.getProperties();
        const layerMap = this.getLayerById(this.layers, layerId);

        const featureProperties = feature.getProperties();
        const popup = layerMap ? layerMap.popup : false;

        if (popup) {
          const displayeFields = [];
          // Object.keys(featureProperties).forEach((key) => {
          //   console.log(key, `${featureProperties[key]}`);
          // });

          if (popup.fields) {
            Object.keys(popup.fields).forEach((fieldKey) => {
              let fieldValue = featureProperties[popup.fields[fieldKey]];

              if (fieldValue && (fieldValue != null) && (typeof fieldValue !== 'undefined')) {
                // detect and convert unix dates
                if (Number.isInteger(fieldValue)
                  && fieldValue.toString().length === 13
                  && moment(fieldValue, ['x', 'X'], true).isValid()) {
                  // Convert to human readable date
                  fieldValue = moment(fieldValue).format('ddd, MMM Do YYYY, h:mm a');
                }

                // handle newlines as html
                if (typeof fieldValue === 'string') {
                  if (fieldValue.includes('http')) {
                    fieldValue = `<a href="${fieldValue}" target="_blank">${fieldValue}</a>`;
                  }
                  fieldValue = fieldValue.replace(/(?:\r\n|\r|\n)/g, '<br>');
                }

                displayeFields.push({
                  key: `${feature.getId()}-${fieldKey}`,
                  fieldName: fieldKey,
                  fieldValue,
                });
              }
            });
          }

          const tile = {
            key: feature.getId(),
            headline: popup.title,
            note: popup.note,
            img: featureProperties[popup.image] || false,
            link: featureProperties[popup.link] || false,
            directions: featureProperties[popup.map] || false,
            html: featureProperties[popup.html] || false,
            displayFields: displayeFields,
            imgLoadError: false,
          };

          // better to push to the store so results stream in
          if (!this.getIsDetailsViewVisible) {
            this.setDetailViewVisible(true);
          }
          this.pushToTilesArray(tile);
        }
      }, {
        hitTolerance: 10,
      });
    },

    initializeMap() {
      return new Map({
        target: 'map',
        controls: defaultControls({
          attributionOptions: {
            collapsible: false,
          },
        }).extend([
          scaleLineControl,
        ]),
        loadTilesWhileAnimating: true,
        layers: [
          new TileLayer({
            source: new XYZ({
              url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            }),
          }),
        ],
      });
    },

    updateMapView(center, zoom) {
      return new View({
        center,
        zoom,
        enableRotation: false,
      });
    },

    animateMapCenter(newMapCenter, minZoom) {
      mapView.animate({
        center: newMapCenter,
        duration: 500,
        zoom: (mapView.getZoom() < minZoom) ? minZoom : mapView.getZoom(),
      });
    },

    mapResizeHandler() {
      this.$nextTick(() => {
        map.updateSize();
      });
    },

    geolocateHandler() {
      navigator.geolocation.getCurrentPosition(
        this.geolocationPositionHandler,
        this.geolocationErrorHandler,
      );
    },

    // eslint-disable-next-line no-unused-vars
    flyToHandler(location, extent) {
      const newMapCenter = [location.x, location.y];
      this.animateMapCenter(newMapCenter, 10);
      positionFeature.setGeometry(newMapCenter ? new Point(newMapCenter) : null);
    },

    geolocationPositionHandler(position) {
      const newGeolocation = fromLonLat([position.coords.longitude, position.coords.latitude]);
      this.flyToHandler({ x: newGeolocation[0], y: newGeolocation[1] }, null);
      this.$bus.$emit('map-has-geolocated');
    },

    geolocationErrorHandler(error) {
      this.$bus.$emit('map-geolocation-error', error);
      switch (error.code) {
        case 3:
          console.log('Geolocation timed out');
          break;
        case 2:
          console.log('Device cannot get geolocation data');
          break;
        case 1:
          console.log('User refused to make geolocation available');
      }
    },

    updateLayersFromSourcesHandler() {
      // eslint-disable-next-line no-unused-vars
      this.layers.forEach((layer, index) => {
        layer.source.refresh();
      });
    },

    layerVisibilityHandler(id, active, loadState) {
      const layer = this.getLayerById(this.layers, id);
      if (loadState === 'error' && active) {
        this.initializeLayer(layer);
      }
      if (layer) this.setLayerVisibility(layer, active);
    },

    layerOpacityHandler(id, opacity) {
      console.log('layerOpacityHandler', id, opacity);
      const layer = this.getLayerById(this.layers, id);
      if (layer) this.setLayerOpacity(layer, Number(opacity));
    },

    mapMoveEndHandler() {
      this.setMapViewStateCenter(mapView.getCenter());
      this.setMapViewStateZoom(mapView.getZoom());

      console.log('mapView.calculateExtent()', mapView.calculateExtent());
      // [minx, miny, maxx, maxy]
      console.log('minx', mapView.calculateExtent()[0]);
      console.log('miny', mapView.calculateExtent()[1]);
      console.log('maxx', mapView.calculateExtent()[2]);
      console.log('maxy', mapView.calculateExtent()[3]);

      const tE = transformExtent(mapView.calculateExtent(), 'EPSG:3857', 'EPSG:4326');
      console.log('transformExtent: ', tE.toString());
      const geoServerBBox = `${tE[1].toFixed(2)},${tE[0].toFixed(2)},${tE[3].toFixed(2)},${tE[2].toFixed(2)}`;
      console.log('geoServerBBox :: ', geoServerBBox);
      console.log('bboxPolygon', bboxPolygon(tE));
      console.log('firmsBBox', bboxPolygon(tE).bbox);

      console.log('mapView.getResolution()', mapView.getResolution());
      console.log('mapView.getCenter()', mapView.getCenter());
      console.log('mapView.getZoom()', mapView.getZoom());
    },

    reorderLayersHandler() {
      this.layers.forEach((layer) => {
        const control = this.getNavigationControlById(layer.id);
        const zindex = (this.navigationState.length + 1) - control.zindex;
        this.$set(layer, 'zIndex', zindex);
        layer.layer.setZIndex(zindex);
      });
    },

    initializeLayer(layer) {
      this.setNavigationLoadState({ id: layer.id, loadState: '' });
      // get navigation index
      // navigationState
      const control = this.getNavigationControlById(layer.id);
      const zindex = (this.navigationState.length + 1) - control.zindex
      || (this.navigationState.length + 1) - this.navigationState.findIndex(
        navControl => navControl.id === layer.id,
      );
      this.$set(layer, 'zIndex', zindex);

      // Set initial visibility here to match navigation
      if (control) this.$set(layer, 'visible', control.active);

      if (layer.type === 'geojson') {
        if (layer.isRangerLayer) {
          this.$set(layer, 'visible', false);
          this.rangerLayer = layer;
        }
        if (layer.visible) {
          this.setNavigationLoadState({ id: layer.id, loadState: 'loading' });
        }

        const newSource = new VectorSource({
          format: new GeoJSON(),
        });

        if (!layer.isRangerLayer) newSource.setLoader = this.geoJsonLoader(layer);

        this.$set(layer, 'source', newSource);

        const newLayer = new VectorLayer(this.getLayerOptions(layer));
        newLayer.setStyle(this.styleFunction);

        // console.log('layer.minResolution', layer.minResolution);
        if (layer.minResolution !== undefined) newLayer.setMinResolution(layer.minResolution);
        if (layer.maxResolution !== undefined) newLayer.setMaxResolution(layer.maxResolution);

        layer.source.on('addfeature', (event) => {
          event.feature.set('layerId', layer.id);
        });

        newLayer.setZIndex(zindex);
        // TODO: Set map layer visibility
        this.addMapLayer(layer, newLayer);
      }

      if (layer.type === 'esrijson') {
        if (layer.visible) {
          this.setNavigationLoadState({ id: layer.id, loadState: 'loading' });
        }

        const newSource = new VectorSource({
          format: new EsriJSON(),
          loader: this.geoJsonLoader(layer),
        });

        this.$set(layer, 'source', newSource);

        const newLayer = new VectorLayer(this.getLayerOptions(layer));
        newLayer.setStyle(this.styleFunction);

        layer.source.on('addfeature', (event) => {
          event.feature.set('layerId', layer.id);
        });

        newLayer.setZIndex(zindex);
        this.addMapLayer(layer, newLayer);
      }


      if (layer.type === 'arcgisrestmapeserver') {
        const newSource = new ImageArcGISRest({
          ratio: layer.ratio,
          params: this.parseParams(layer.params),
          url: this.parseEndpoint(layer.endpoint),
          crossOrigin: 'Anonymous',
        });
        this.$set(layer, 'source', newSource);

        const newLayer = new ImageLayer(this.getLayerOptions(layer));

        this.imageLoadEventing(layer);
        newLayer.setZIndex(zindex);
        this.addMapLayer(layer, newLayer);
      }

      if (layer.type === 'imagewms') {
        const fK = this.firmsKey();
        const endpoint = layer.endpoint.replace('<firmsKey>', fK);
        const newSource = new ImageWMS({
          ratio: layer.ratio,
          params: this.parseParams(layer.params),
          url: this.parseEndpoint(endpoint),
          // crossOrigin: 'anonymous'
        });
        this.$set(layer, 'source', newSource);

        const newLayer = new ImageLayer(this.getLayerOptions(layer));

        this.imageLoadEventing(layer);
        newLayer.setZIndex(zindex);
        this.addMapLayer(layer, newLayer);
      }

      if (layer.type === 'xyz') {
        console.log(layer);
        const newSource = new XYZ({
          url: this.parseEndpoint(layer.endpoint),
        });
        if (layer.tilePixelRatio !== undefined) {
          newSource.set('tilePixelRatio', layer.tilePixelRatio);
        }
        this.$set(layer, 'source', newSource);

        const newLayer = new TileLayer(this.getLayerOptions(layer));
        newLayer.setPreload(Infinity);

        // tiles have special events, because OpenLayers
        // TODO: Debounce these
        newSource.on('tileloadstart', () => {
          this.setNavigationLoadState({ id: layer.id, loadState: 'loading' });
        });
        newSource.on('tileloadend', () => {
          this.setNavigationLoadState({ id: layer.id, loadState: '' });
        });
        newSource.on('tileloaderror', (e) => {
          console.log('Load Error', e);
          if (layer.suppressErrors) {
            this.setNavigationLoadState({ id: layer.id, loadState: '' });
          } else {
            this.setNavigationLoadState({ id: layer.id, loadState: 'error' });
            this.setLayerVisibility(layer, false);
            this.setNavigationActive({ id: layer.id, active: false });
          }
        });
        newLayer.setZIndex(zindex);
        this.addMapLayer(layer, newLayer);
      }

      this.setLayerVisibility(layer, control.active);
      this.setLayerOpacity(layer, Number(control.opacity) || 0.75);
    },

    initializeLayers(layers) {
      layers.forEach((layer) => {
        this.initializeLayer(layer);
      });
    },

    addMapLayer(layer, newLayer) {
      this.$set(layer, 'layer', newLayer);
      map.addLayer(layer.layer);
    },

    getLayerOptions(layer) {
      return {
        source: layer.source,
        visible: layer.visible,
        opacity: layer.opacity,
        zIndex: layer.zIndex,
      };
    },

    imageLoadEventing(layer) {
      layer.source.on('imageloadstart', () => {
        this.setNavigationLoadState({ id: layer.id, loadState: 'loading' });
      });

      layer.source.on('imageloaderror', () => {
        console.log(layer.id, 'imageloaderror');
        // console.log('imageloaderror', layer.id);
        this.setNavigationLoadState({ id: layer.id, loadState: 'error' });
        this.setLayerVisibility(layer, false);
        this.setNavigationActive({ id: layer.id, active: false });
      });

      layer.source.on('imageloadend', () => {
        this.setNavigationLoadState({ id: layer.id, loadState: '' });
      });
    },

    // eslint-disable-next-line no-unused-vars
    styleFunction(feature, resolution) {
      const layer = this.getLayerById(this.layers, feature.getProperties().layerId);
      const geomName = feature.getGeometry().getType();

      let returnStyle = null;

      if (layer.style && style[layer.style] && style[layer.style][geomName]) {
        returnStyle = style[layer.style][geomName](feature, resolution);
      } else {
        returnStyle = this.defaultStyles(layer, feature, resolution);
      }
      const textStyle = this.getTextStyle(layer, feature, resolution);
      if (returnStyle && textStyle) {
        returnStyle.setText(textStyle);
      }

      return returnStyle;
    },

    // eslint-disable-next-line no-unused-vars
    getTextStyle(layer, feature, resolution) {
      let textStyle = null;
      if (layer.label) {
        let labelText = '';

        if (resolution < this.labelBreakpoint) {
          if (feature.getProperties()[layer.label] && feature.getProperties()[layer.label].toString().length > 0) labelText += layer.labelPrefix || '';
          labelText += feature.getProperties()[layer.label] || '';
        }

        // textStyle = new Text({
        //   text: labelText,
        //   textAlign: 'left',
        //   placement: 'wrap',
        //   offsetX: 18,
        //   font: '12px Arial',
        //   align: 'center',
        //   baseline: 'middle',
        //   fill: new Fill({
        //     color: '#003D6B',
        //   }),
        //   stroke: new Stroke({
        //     color: '#cccccc',
        //     width: 3,
        //   }),
        // });
        textStyle = defaultTextStyle;
        textStyle.setText(labelText);
      }
      return textStyle;
    },

    // eslint-disable-next-line no-unused-vars
    defaultStyles(layer, feature, resolution) {
      const geometryStyles = [];

      const stroke = layer.oStroke ? layer.oStroke : false
                    || (typeof feature.getProperties().stroke !== 'undefined') ? { color: `${feature.getProperties().stroke}`, width: 3 } : false
                    || (typeof feature.getProperties()['marker-color'] !== 'undefined') ? { color: `${feature.getProperties()['marker-color']}`, width: 3 } : false
                    || { color: [0, 0, 0, 1], width: 3 };

      const fill = layer.oFill ? layer.oFill : false
                  || (typeof feature.getProperties()['marker-color'] !== 'undefined') ? { color: `${feature.getProperties()['marker-color']}` } : { color: [255, 255, 255, 1] };


      if (layer.oImageOptions) {
        geometryStyles.Point = new Style({
          image: new Icon(/** @type {module:ol/style/Icon~Options} */ (layer.oImageOptions)),
        });
      } else {
        geometryStyles.Point = new Style({
          stroke: new Stroke(stroke),
          image: new CircleStyle({
            fill: new Fill(fill),
            radius: 5,
          }),
        });
      }

      geometryStyles.LineString = new Style({
        stroke: new Stroke(stroke),
        fill: new Fill(fill),
      });
      geometryStyles.Polygon = new Style({
        stroke: new Stroke(stroke),
        fill: new Fill(fill),
      });
      geometryStyles.MultiPolygon = new Style({
        stroke: new Stroke(stroke),
        fill: new Fill(fill),
      });
      return geometryStyles[feature.getGeometry().getType()];
    },

    geoJsonLoader(layer, box) {
      let { endpoint } = layer;
      if (layer.params !== undefined) {
        const params = this.parseParams(layer.params);
        Object.keys(params).forEach((key) => {
          endpoint += `&${key}=${params[key]}`;
        });
      }

      if (box) endpoint += `&bbox=${box}`;

      axios.get(this.parseEndpoint(endpoint), { timeout: 120000 })
        .then((response) => {
          this.setNavigationLoadState({ id: layer.id, loadState: '' });
          const projectionsConversion = (layer.dataProjection) ? { dataProjection: layer.dataProjection, featureProjection: 'EPSG:3857' } : {};
          const f = layer.source.getFormat();
          const projectedFeatures = f.readFeatures(response.data, projectionsConversion);
          layer.source.addFeatures(projectedFeatures);
          if (layer.canRange) {
            this.rangeableFeaturesCollections.push(response.data);
          }
        })
        .catch((e) => {
          this.setNavigationLoadState({ id: layer.id, loadState: 'error' });
          this.setLayerVisibility(layer, false);
          this.setNavigationActive({ id: layer.id, active: false });
          // eslint-disable-next-line no-console
          console.log('Load Error: ', layer.id, layer.endpoint, e);
        });
    },

    getLayerById(layers, id) {
      return layers.filter(layer => layer.id === id)[0];
    },

    getRangerLayers(layers) {
      return layers.filter(layer => layer.canRange);
    },

    setLayerOpacity(layer, opacity) {
      layer.layer.setOpacity(Number(opacity));
    },

    setLayerVisibility(layer, visibility) {
      layer.layer.setVisible(visibility);

      if (layer.type === 'geojson' && layer.loadState === 'error' && layer.visible) {
        this.setNavigationLoadState({ id: layer.id, loadState: 'loading' });
        layer.source.setLoader(this.geoJsonLoader(layer));
      }
    },

    parseEndpoint(endpoint) {
      if (endpoint.indexOf('${') !== -1) {
        return evaluate(endpoint,
          { plumeURL: this.plumeURL },
          { moment },
          { stringInterpolationMode: true });
      }
      return endpoint;
    },

    parseParams(params) {
      const parsedParams = {};
      Object.keys(params).forEach((key) => {
        const temp = params[key];
        if (typeof temp === 'string' && temp.indexOf('${') !== -1) {
          parsedParams[key] = evaluate(
            temp,
            { plumeURL: this.plumeURL },
            { moment },
            { stringInterpolationMode: true },
          );
        } else {
          parsedParams[key] = `${params[key]}`;
        }
      });
      // console.log('parseParams >>>>>>>>>', parsedParams);
      return parsedParams;
    },

  },
};
</script>

<style>
.ol-scale-line {
  bottom: 68px !important;
}
</style>
<style scoped>
.map {
  height: 100vh;
  width: 100%;
}
</style>
